import * as React from 'react';
import { PassengerFragment } from '@websky/graphql';
import { Money as MoneyType } from '../../../../../../types';
import Money from '../../../../../../Money';
import { default as Button } from '../../../../../../Button';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';
import { Tooltip } from '../../../../../../BaseComponents';
import { getTravellerName } from '../../../../../../utils';

interface Props {
	traveller: PassengerFragment;
	price: MoneyType;
	isSelected?: boolean;
	onClick: () => void;
	tooltipText?: string;
	disabled?: boolean;
	isConfirmed?: boolean;
}

const EveryPortTraveller: React.FC<Props> = ({
	traveller,
	price,
	isSelected,
	onClick,
	tooltipText,
	disabled,
	isConfirmed
}) => {
	const { t } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;

	return (
		<div className={theme.traveller}>
			<div className={theme.traveller__name}>{getTravellerName(traveller)}</div>

			<div className={theme.traveller__controls}>
				<Money money={price} />

				{!isConfirmed && (
					<Tooltip open={!!tooltipText} title={tooltipText}>
						<div>
							<Button
								onClick={onClick}
								className={cn(theme.button_passenger, theme.button, {
									[theme.button_selected]: isSelected,
									[theme.button_disabled]: disabled
								})}
								disabled={disabled}
							>
								{t(isSelected ? 'Cancel' : 'Select')}
							</Button>
						</div>
					</Tooltip>
				)}
			</div>
		</div>
	);
};

export default EveryPortTraveller;
